import React from 'react'
import Nav from '../utils/Navbar/Nav'
import Clock from './parts/Clock';
import ContactFaq from './parts/ContactFaq';
import CustomerReview from './parts/CustomerReview';
import FeaturesMain from './parts/FeaturesMain';
import { Box } from '@mui/material';
import Simplify from './parts/Simplify';
import IconSection from './parts/IconSection';
import Name from './parts/Name';
import Footer from '../utils/utils/Footer';
import CtsRow from './parts/CtsRow';

const Home = () => {
  return (
    <Box maxWidth={"1600px"} margin={"0 auto"} fontFamily={"Work Sans"}>
      <Nav />
      <Simplify />
      <FeaturesMain />
      <CtsRow/>
      <IconSection/>
      <CustomerReview />
      <Name/>
      <Clock />
      <ContactFaq />
      <Footer/>
    </Box>
  );
}

export default Home